import { useSelector } from 'react-redux';

import { IExportState, selectExportState } from './exportSlice';

export const useExportState = (): IExportState => useSelector(selectExportState);
